import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Contact from "../pages/contact/page";
import Downloads from "../pages/downloads/page";
import Dormitory from "../pages/dormitory/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/downloads",
    element: <Downloads />,
  },
  {
    path: "/dormitory",
    element: <Dormitory />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
